import React, {useRef} from "react";
import {CopyToClipboard} from "react-copy-to-clipboard";
import Modal, {Content, Header} from "ui-components-rollup/dist/Modal";
import {SyntaxHighlighter} from "ui-components";
import styles from "./PermissionsModal.module.scss";

export default ({closeDialog, permissions, title}) => {
    const buttonRef = useRef(null);
    return (
        <Modal closeTrigger={closeDialog} target={() => buttonRef.current}>
            <Header closeTrigger={closeDialog}>
                Required Permissions
            </Header>
            <Content>
                <div className={styles["text"]}>{title}</div>
                <div className={styles["permissions"]}>
                    <CopyToClipboard text={permissions}>
                        <button className={styles["button"]}>Copy to clipboard</button>
                    </CopyToClipboard>
                    <SyntaxHighlighter language="json" customStyle={{ background: "rgb(246, 246, 246)", borderRadius: 4 }}>
                        {permissions}
                    </SyntaxHighlighter>
                </div>
            </Content>
        </Modal>
    );
};
